module.exports = __webpack_public_path__ + "static/media/ordenacao.c4106d64.png";